class ElTimerAnnouncement {
  constructor(section) {
    this.section = section;
    this.hoursEl = section.querySelector("[data-el-timer-hours]");
    this.minutesEl = section.querySelector("[data-el-timer-minutes]");
    this.secondsEl = section.querySelector("[data-el-timer-seconds]");

    this.referenceDate = section.dataset.referenceDate;
    this.referenceTime = section.dataset.referenceTime;
    this.targetDate = section.dataset.targetDate;
    this.targetTime = section.dataset.targetTime;

    this.interval = null;

    this.init();
  }

  init() {
    const reference = this.parseDateTime(this.referenceDate, this.referenceTime);
    const target = this.parseDateTime(this.targetDate, this.targetTime);

    if (!reference || !target) return;

    this.referenceTimestamp = reference.getTime();
    this.targetTimestamp = target.getTime();
    this.duration = this.targetTimestamp - this.referenceTimestamp;

    if (this.duration <= 0) return;

    this.updateTimer();
    this.interval = setInterval(() => this.updateTimer(), 1000);
  }

  parseDateTime(dateStr, timeStr) {
    if (!dateStr || !timeStr) return null;

    const fullDate = `${dateStr}T${timeStr}`;
    const parsed = new Date(fullDate);

    if (Number.isNaN(parsed.getTime())) return null;

    return parsed;
  }

  updateTimer() {
    const now = Date.now();
    let remaining;

    if (now < this.referenceTimestamp) {
      remaining = this.targetTimestamp - now;
    } else {
      const elapsedSinceReference = now - this.referenceTimestamp;
      const elapsedInCycle = elapsedSinceReference % this.duration;
      remaining = this.duration - elapsedInCycle;

      if (remaining === this.duration) {
        remaining = 0;
      }
    }

    const totalSeconds = Math.max(remaining > 0 ? Math.floor(remaining / 1000) : 0, 0);

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    this.render(hours, minutes, seconds);
  }

  render(hours, minutes, seconds) {
    if (this.hoursEl) this.hoursEl.textContent = String(hours).padStart(2, "0");
    if (this.minutesEl) this.minutesEl.textContent = String(minutes).padStart(2, "0");
    if (this.secondsEl) this.secondsEl.textContent = String(seconds).padStart(2, "0");
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const sections = document.querySelectorAll(".el-timer-announcement");

  sections.forEach((section) => {
    new ElTimerAnnouncement(section);
  });
});